import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import ConfirmEmailPopup from './ConfirmEmailPopup';

const ConfirmEmailPreview = (props) => {
    const popupRef = useRef(null);
    const { emailConfirmTitle, emailConfirmInfo, emailNextButton, emailCancelButton } = usePageMessages();

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="mail-80"
                iconColor="primary"
                headerText={getText(emailConfirmTitle)}
                secondaryText={emailConfirmInfo}
                topButtonType="link"
                topButtonCaption={emailCancelButton}
                topButtonOnClick={(e) => {
                    e?.preventDefault();
                    props?.toggleSpinner(true);
                    window.location.replace(AUTH_SEND_MAIN_LINK);
                }}
                primaryButtonType="button"
                primaryButtonCaption={emailNextButton}
                primaryButtonOnClick={(e) => {
                    e.preventDefault();
                    popupRef.current?.open(<ConfirmEmailPopup popupRef={popupRef} />);
                }}
            />
            <PopupNew ref={popupRef} />
        </BaseLayout>
    );
};

export default connect(null, { toggleSpinner })(ConfirmEmailPreview);
